window._ = require('lodash');

window.translate = function (key, replace) {
  let translation, translationNotFound = true

  try {
    translation = key.split('.').reduce((t, i) => t[i] || null, window._translations)

    if (translation) {
      translationNotFound = false
    }
  } catch (e) {
    translation = key
  }

  if (translationNotFound) {
    translation = window._translations[window._locale][key]
      ? window._translations[window._locale][key]
      : key
  }

  _.forEach(replace, (value, key) => {
    translation = translation.replace(':' + key, value)
  })

  return translation
};

module.exports = {
  methods: {
    /**
     * Translate the given key.
     */
    __(key, replace) {
      return translate(key, replace);
    }
  },
}
